export default "__VITE_ASSET__220b4993__"